import { EventEmitter } from 'events';
import { User, Session, Device, UsersAPI } from 'src/api';
import MapUtils from 'src/api/requests/jsonparser';

export default class KDGlobal {
    private static _instance = new KDGlobal()
    private eventEmitter: EventEmitter;
    private user?: User;
    private device?: Device;
    public static get instance() {
        return KDGlobal._instance
    }

    constructor() {
        this.eventEmitter = new EventEmitter();
        if (localStorage['current_device']) {
            try {
                let device = JSON.parse(localStorage['current_device'])
                if (device && device.user) {
                    Session.setSession(device.session_token)
                    let real_device: Device | undefined = MapUtils.deserialize(Device, device)
                    if (real_device) {
                        this.user = real_device.user
                        this.device = real_device
                        UsersAPI.getMe().then((user) => {
                            this.setUser(user)
                        })
                    }
                }
            } catch (error) {

            }
        }
    }

    unsetUser() {
        this.user = undefined;
        localStorage.removeItem('current_device')
        Session.setSession(undefined)
    }

    setUser(user: User, device?: Device, emit: boolean = false) {
        this.user = user;
        if (device) {
            this.device = device;
            Session.setSession(device.session_token)
            localStorage['current_device'] = JSON.stringify(device);
        } else {
            if (this.device) {
                this.device.user = user;
                Session.setSession(this.device.session_token)
                localStorage['current_device'] = JSON.stringify(this.device);
            }
        }
        emit && this.emit('user', [user])
    }

    getUser() {
        return this.user
    }

    removeEventListener(eventName: string, listener: (...args: any[]) => void) {
        this.eventEmitter.removeListener(eventName, listener);
    }

    on(eventName: string, listener: (...args: any[]) => void) {
        this.eventEmitter.on(eventName, listener);
    }

    emit(event: string, payload: any[], error = false) {
        this.eventEmitter.emit(event, payload, error);
    }

}


// WEBPACK FOOTER //
// ./src/components/Global.ts